export default __webpack_public_path__ + "static/media/image6.6509012b.jpeg";